import apiFetch from '../apiFetch'

export default function (token, customField) {
  return apiFetch({ endPoint: `Masters/CustomField/${customField.customFieldId}`, method: 'PUT', body: customField, token: token })
}
